import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6aff4bee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "indicator-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "indicator_rec" }, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 클럽딜 열기 ")
const _hoisted_4 = { class: "wrapper" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container_title title_24B" }, [
  /*#__PURE__*/_createTextVNode(" 원하는 주식 클럽딜?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 내가 직접 열 수 있어요! ")
], -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 매물을 선택해서 판매자와 협의 후 클럽딜을 열어보세요 ")
const _hoisted_8 = { class: "sell_item_box" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "main_14R deep-blue" }, "보유주식 팔면 수수료 0원, 100,000P 적립", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title_16B" }, "보유 주식 팔기", -1))
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_text_s = _resolveComponent("ag-text-s")!
  const _component_ag_icon = _resolveComponent("ag-icon")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_prepare_deals = _resolveComponent("prepare-deals")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_ag_box_s, { css: {color: 'font', dp: 'flex', mx: 20, borderBottom: '1px solid #EEF1F7', minHeight: 40} }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_text_s, { css: {typography: 'main16r', grow: 1, textAlign: 'start'} }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_ag_box_s, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'헤더', 'clickContent':`공유버튼`});_ctx.onShare()})
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_icon, {
                name: "arrowRedo",
                css: {width: 26, height: 26, color: 'gray6'}
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_ion_content, { class: "cp__content" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_ag_box_s, { css: {typography: 'text14r', color:'gray2'} }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("button", {
                class: "blue_btn sell_item_btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'상단버튼', 'clickContent':`보유 주식 팔기`});(_ctx.user === null ? _ctx.$global.openLoginModal() : _ctx.openSellModal('collectPartnership'))})
              }, _hoisted_11)
            ]),
            _createVNode(_component_prepare_deals, { "prepare-deals": _ctx.preparesPartnerships }, null, 8, ["prepare-deals"])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}